import { useTranslation } from '@/i18n';
import ServicePlanCustomerReminderControl from '@/ui/components/servicePlanCustomerReminderControl/ServicePlanCustomerReminderControl';
import AuthenticatedPageWrapper from '@/ui/pages/pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

interface IProps {}

const ServicePlansCustomerReminders: FC = () => {
  const { customerReminderId } = useParams<{ customerReminderId?: string }>();
  const translate = useTranslation();

  const isCreatingReminder = customerReminderId === 'new';

  return (
    <>
      <Helmet title={translate('pages.servicePlanCustomerReminders.title')} />
      <AuthenticatedPageWrapper
        className="service-plan-page"
        breadcrumbItems={[
          { label: 'Back', to: '/service-plans/customer-reminders' },
          { label: 'Customer Reminder' },
        ]}
      >
        <div className="typography:prose">
          <h1 className="px-8 py-4">
            {isCreatingReminder
              ? 'New Customer Reminder'
              : 'Edit Customer Reminder'}
          </h1>
        </div>
        <div className="p-4">
          <ServicePlanCustomerReminderControl
            servicePlanCustomerReminderPublicId={
              !isCreatingReminder ? customerReminderId : undefined
            }
          />
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default ServicePlansCustomerReminders;
